import AddRestaurant from "view3/Main.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    categories: state.categories,
    alert: state.alert,
    city: state.city
  };
}

const AddRestaurantContainer = connectFunction(mapStateToProps)(AddRestaurant);
export default AddRestaurantContainer;
